import { getAreExperimentsLoading, getEligiblePublicTreatments, getExperimentByTreatmentKey, getHasExperimentsFetchSucceeded } from '../utils/experimentationUtils';
export const areExperimentsLoadingSelector = state => {
  return getAreExperimentsLoading(state);
};
export const hasExperimentsFetchSucceededSelector = state => {
  return getHasExperimentsFetchSucceeded(state);
};
export const experimentByTreatmentKeySelector = (state, treatmentKey) => {
  return getExperimentByTreatmentKey(state, treatmentKey);
};
export const getEligiblePublicTreatmentsSelector = state => {
  return getEligiblePublicTreatments(state);
};